import styled from 'styled-components';

const StyledAudienceOpener = styled.div`
  position: relative;
  border-color: ${props =>
    props.isDropping && !props.isDisabled
      ? props.theme.colors.primary
      : props.theme.colors.light_darker_1};
  border-style: dotted;
  border-width: 4px;
  border-radius: 10px;
  margin: 5px;
  cursor: ${props => (props.isDisabled ? 'not-allowed' : '')};
  &::after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`;

const StyledAudienceOpenerContent = styled.div`
  position: absolute;
  pointer-events: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 35px;
  border-radius: 4px;
  background-color: ${props =>
    props.isDropping && !props.isDisabled
      ? props.theme.colors.light_darker
      : props.theme.colors.light_dark};
`;

const StyledDroppingEntity = styled.div`
  height: 30px;
  width: 100%;
  padding: 20px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  pointer-events: visible;
  background-color: ${props => props.theme.colors.primary};
`;

export {
  StyledAudienceOpener,
  StyledAudienceOpenerContent,
  StyledDroppingEntity,
};
